var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"van-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"m-scroll-top",on:{"click":_vm.onClick}},[_vm._v("Top")])])}
var staticRenderFns = []

export { render, staticRenderFns }